import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-maria-alvarado',
  templateUrl: './maria-alvarado.component.html',
  styleUrls: ['./maria-alvarado.component.scss']
})
export class MariaAlvaradoComponent implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle("MARÍA JESÚS ALVARADO RIVERA");
  }

  ngOnInit(): void {
  }

  slides = [
    { id: "http://hdl.handle.net/20.500.14428/79653", img: "/assets/images/micrositio/micrositio26/PRENSA-005.jpg", autor: "El Peruano. ", anno: "No. XXXVI (31 de diciembre de 1811). ", anuNacimiento: "No. 1 (6 de setiembre 1811)-" },
    { id: "http://hdl.handle.net/20.500.14428/79658", img: "/assets/images/micrositio/micrositio26/PRENSA-006.jpg", autor: "El Verdadero Peruano. ", anno: "La BNP dispone del Prospecto (1811), y los números I (1812) al VII (5 de noviembre de 1812). ", anuNacimiento: "El Prospecto se publicó en 1811 y las sucesivas ediciones entre 1812 y 1813 (Tomo I: 1812-1813 (I-XXVIII) Tomo II: 1813 (I-XVII)) " },
    { id: "http://hdl.handle.net/20.500.14428/79656", img: "/assets/images/micrositio/micrositio26/PRENSA-007.jpg", autor: "El Argos Constitucional. ", anno: "No. 7 (21 de marzo de 1813), además de un Prospecto sin fecha.", anuNacimiento: "No. 1 (7 de febrero de 1813) al" },
    { id: "http://hdl.handle.net/20.500.14428/79659", img: "/assets/images/micrositio/micrositio26/PRENSA-008.jpg", autor: "El Anti-Argos.", anno: "No. 3 (12 de marzo de 1813) ", anuNacimiento: "No. 1 (11 de febrero de 1813) al" },
    { id: "http://hdl.handle.net/20.500.14428/79660", img: "/assets/images/micrositio/micrositio26/PRENSA-009.jpg", autor: "El Investigador. ", anno: "No. 80  (18 de setiembre de 1814). ", anuNacimiento: "Del No. 1 (1 de julio de 1813) al " }
  ];


  slideConfig = {
    "slidesToShow": 5, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 850,
        'settings': {
          'slidesToShow': 1
        }
      }
    ]
  };

}
